module.exports = __webpack_public_path__ + "img/img-31.8e5edfb7.png";